var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c.153 0 .306.003.457.01l.031.002c.126.006.252.014.377.025l-.408-.027a10.094 10.094 0 012.203.348C18.89 3.522 22 7.398 22 12c0 4.602-3.11 8.479-7.341 9.643 0-.001 0 0 0 0l-.05.013a9.892 9.892 0 01-.354.089l.405-.103a9.938 9.938 0 01-1.295.266l-.03.004a10.051 10.051 0 01-.847.076l-.03.002c-.152.007-.305.01-.458.01-5.523 0-10-4.477-10-10S6.477 2 12 2zm.967 1.554l-.058.053C10.878 5.48 9.5 8.462 9.5 12c0 3.572 1.404 6.577 3.467 8.445a8.501 8.501 0 000-16.89zm-2.088.02l-.135.018a8.502 8.502 0 000 16.816l.135.017C9.1 18.26 8 15.283 8 12c0-3.283 1.099-6.259 2.88-8.425zM17.5 10.5a1 1 0 110 2 1 1 0 010-2zM16 7a1.25 1.25 0 110 2.5A1.25 1.25 0 0116 7z",
    fill: "currentColor"
  })));
}

export default SvgWeb;